var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useMemo, useCallback, useRef, } from "react";
import { useIntl } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import { useQueries, useMutation, useQueryClient } from "react-query";
import { Modal, ModalFooter, Button, Checkbox, Loading, MessageBanner, Accordion, AccordionSet, AccordionStatus, ExpandAllButton, } from "@folio/stripes/components";
import { fetchVolumeMatrix } from "../../api/periodicalIssueService";
import { ISSUE_MATRIX_KEY, usePeriodicalVolumes, } from "../../hooks/usePeriodicalVolumes";
import { toIsoDateString } from "../../utils/isoDate";
import { sortVolumesByStart } from "../../utils/volumeWindow";
import { previewUrgence, createUrgence, previewDamagedClaimByRecords, createDamagedClaim, } from "../../api/enforcementService";
import { useIssueDateFormatter } from "../../hooks/useIssueDateFormatter";
import { UrgenceSkipReasonEnum } from "../../types/enforcement";
import { readUrgenceErrorCode, summarizeSkippedRecords, } from "../../utils/urgenceSkipSummary";
import { SendEnforcementDialog } from "../enforcement/SendEnforcementDialog";
import css from "./PeriodicalEnforcementDialog.module.css";
import { invalidateDepositRecordViews } from "../../utils/depositRecordQueries";
var VOLUMES_OFFERED = 3;
var VolumeCheckbox = function (_a) {
    var label = _a.label, checked = _a.checked, indeterminate = _a.indeterminate, onChange = _a.onChange;
    var inputRef = useRef(null);
    useEffect(function () {
        if (inputRef.current) {
            inputRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);
    return (React.createElement(Checkbox, { label: label, checked: checked, onChange: onChange, inputRef: inputRef }));
};
var relevantDrIds = function (issue, kind) {
    var _a, _b;
    return kind === "DAMAGED_CLAIM"
        ? ((_a = issue.damagedDepositRecordIds) !== null && _a !== void 0 ? _a : [])
        : ((_b = issue.overdueDepositRecordIds) !== null && _b !== void 0 ? _b : []);
};
var DIALOG_TITLE_IDS = {
    URGENCE: "ui-br-legaldeposits.periodicals.enforcement.urgence.selectTitle",
    REMINDER: "ui-br-legaldeposits.periodicals.enforcement.reminder.selectTitle",
    DAMAGED_CLAIM: "ui-br-legaldeposits.periodicals.enforcement.damagedClaim.selectTitle",
};
var SEND_TITLE_IDS = {
    URGENCE: "ui-br-legaldeposits.periodicals.enforcement.urgence.sendTitle",
    REMINDER: "ui-br-legaldeposits.periodicals.enforcement.reminder.sendTitle",
    DAMAGED_CLAIM: "ui-br-legaldeposits.periodicals.enforcement.damagedClaim.sendTitle",
};
var SUBMIT_NOTE_LABEL_IDS = {
    URGENCE: "ui-br-legaldeposits.button.recordUrgence",
    REMINDER: "ui-br-legaldeposits.periodicals.enforcement.reminder.record",
    DAMAGED_CLAIM: "ui-br-legaldeposits.enforcement.send.damagedClaim.record",
};
var NO_ISSUES_MESSAGE_IDS = {
    URGENCE: "ui-br-legaldeposits.periodicals.enforcement.noOverdue",
    REMINDER: "ui-br-legaldeposits.periodicals.enforcement.noOverdue",
    DAMAGED_CLAIM: "ui-br-legaldeposits.periodicals.enforcement.noDamaged",
};
var ALL_ALREADY_REMINDED_MESSAGE_IDS = {
    URGENCE: "ui-br-legaldeposits.periodicals.enforcement.urgence.allAlreadyReminded",
    REMINDER: "ui-br-legaldeposits.periodicals.enforcement.reminder.allAlreadyReminded",
    DAMAGED_CLAIM: "ui-br-legaldeposits.periodicals.enforcement.damagedClaim.allAlreadyReminded",
};
var SEND_FAILED_MESSAGE_IDS = {
    URGENCE: "ui-br-legaldeposits.periodicals.enforcement.urgence.sendFailed",
    REMINDER: "ui-br-legaldeposits.periodicals.enforcement.reminder.sendFailed",
    DAMAGED_CLAIM: "ui-br-legaldeposits.periodicals.enforcement.damagedClaim.sendFailed",
};
var VOLUME_ACCORDION_LABEL_IDS = {
    URGENCE: "ui-br-legaldeposits.periodicals.enforcement.volumeAccordionLabel",
    REMINDER: "ui-br-legaldeposits.periodicals.enforcement.volumeAccordionLabel",
    DAMAGED_CLAIM: "ui-br-legaldeposits.periodicals.enforcement.damagedClaim.volumeAccordionLabel",
};
export var PeriodicalEnforcementDialog = function (_a) {
    var _b, _c;
    var open = _a.open, onClose = _a.onClose, periodicalLibrary = _a.periodicalLibrary, enforcementKind = _a.enforcementKind, onResult = _a.onResult;
    var _d = useIntl(), formatMessage = _d.formatMessage, formatDate = _d.formatDate;
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var _e = usePeriodicalVolumes(periodicalLibrary.id, open), allVolumes = _e.data, volumesLoading = _e.isLoading;
    var offeredVolumes = useMemo(function () {
        var today = toIsoDateString(new Date());
        return sortVolumesByStart(allVolumes !== null && allVolumes !== void 0 ? allVolumes : [])
            .filter(function (volume) { return volume.startDate <= today; })
            .reverse()
            .slice(0, VOLUMES_OFFERED);
    }, [allVolumes]);
    var _f = useState("select"), phase = _f[0], setPhase = _f[1];
    var _g = useState(new Set()), selectedIssueIds = _g[0], setSelectedIssueIds = _g[1];
    var _h = useState(false), initialized = _h[0], setInitialized = _h[1];
    var _j = useState([]), sendDrIds = _j[0], setSendDrIds = _j[1];
    var _k = useState(null), noticeMessage = _k[0], setNoticeMessage = _k[1];
    var matrixQueries = useQueries(offeredVolumes.map(function (volume) { return ({
        queryKey: [ISSUE_MATRIX_KEY, periodicalLibrary.id, volume.id],
        queryFn: function () {
            return fetchVolumeMatrix(kyInstance, periodicalLibrary.id, volume.id);
        },
        enabled: open,
    }); }));
    var isLoading = volumesLoading || matrixQueries.some(function (q) { return q.isLoading; });
    var enforceableVolumes = useMemo(function () {
        var result = [];
        matrixQueries.forEach(function (q) {
            var data = q.data;
            if (!data)
                return;
            // A double issue running in from the previous volume is a stub carrying the primary's records.
            var enforceableIssues = data.issues.filter(function (issue) {
                return !issue.continuedFromPreviousVolume &&
                    relevantDrIds(issue, enforcementKind).length > 0;
            });
            if (enforceableIssues.length > 0) {
                result.push({ volume: data.volume, issues: enforceableIssues });
            }
        });
        return result;
    }, [matrixQueries, enforcementKind]);
    var allEnforceableIssueIds = useMemo(function () { return enforceableVolumes.flatMap(function (v) { return v.issues.map(function (i) { return i.id; }); }); }, [enforceableVolumes]);
    var newestVolumeId = (_b = offeredVolumes[0]) === null || _b === void 0 ? void 0 : _b.id;
    var newestVolumeIssueIds = useMemo(function () {
        return enforceableVolumes
            .filter(function (v) { return v.volume.id === newestVolumeId; })
            .flatMap(function (v) { return v.issues.map(function (i) { return i.id; }); });
    }, [enforceableVolumes, newestVolumeId]);
    useEffect(function () {
        if (open && !initialized && !isLoading) {
            setSelectedIssueIds(new Set(newestVolumeIssueIds));
            setInitialized(true);
        }
    }, [open, initialized, isLoading, newestVolumeIssueIds]);
    useEffect(function () {
        if (!open) {
            setPhase("select");
            setSelectedIssueIds(new Set());
            setInitialized(false);
            setSendDrIds([]);
            setNoticeMessage(null);
        }
    }, [open]);
    var toggleIssue = useCallback(function (issueId) {
        setSelectedIssueIds(function (prev) {
            var next = new Set(prev);
            if (next.has(issueId)) {
                next.delete(issueId);
            }
            else {
                next.add(issueId);
            }
            return next;
        });
    }, []);
    var toggleVolume = useCallback(function (issues) {
        setSelectedIssueIds(function (prev) {
            var next = new Set(prev);
            var allSelected = issues.every(function (issue) { return next.has(issue.id); });
            issues.forEach(function (issue) {
                if (allSelected) {
                    next.delete(issue.id);
                }
                else {
                    next.add(issue.id);
                }
            });
            return next;
        });
    }, []);
    var selectedDrIds = useMemo(function () {
        return enforceableVolumes
            .flatMap(function (v) { return v.issues; })
            .filter(function (issue) { return selectedIssueIds.has(issue.id); })
            .flatMap(function (issue) { return relevantDrIds(issue, enforcementKind); });
    }, [enforceableVolumes, selectedIssueIds, enforcementKind]);
    var selectedIssueCount = useMemo(function () {
        return enforceableVolumes
            .flatMap(function (v) { return v.issues; })
            .filter(function (issue) { return selectedIssueIds.has(issue.id); }).length;
    }, [enforceableVolumes, selectedIssueIds]);
    var selectedVolumeLabels = useMemo(function () {
        return enforceableVolumes
            .filter(function (v) { return v.issues.some(function (issue) { return selectedIssueIds.has(issue.id); }); })
            .map(function (v) { return v.volume.label; });
    }, [enforceableVolumes, selectedIssueIds]);
    var handleProceed = useCallback(function () {
        setSendDrIds(selectedDrIds);
        setPhase("send");
    }, [selectedDrIds]);
    var previewQuery = useQueries([
        {
            queryKey: ["periodical-enforcement-preview", sendDrIds, enforcementKind],
            queryFn: function () {
                return enforcementKind === "DAMAGED_CLAIM"
                    ? previewDamagedClaimByRecords(kyInstance, sendDrIds)
                    : previewUrgence(kyInstance, sendDrIds, enforcementKind);
            },
            enabled: phase === "send" && sendDrIds.length > 0,
        },
    ])[0];
    var preview = (_c = previewQuery.data) !== null && _c !== void 0 ? _c : null;
    var invalidateMatrices = useCallback(function () {
        queryClient.invalidateQueries([ISSUE_MATRIX_KEY, periodicalLibrary.id]);
    }, [queryClient, periodicalLibrary.id]);
    var sendMutation = useMutation(function (formData) {
        return enforcementKind === "DAMAGED_CLAIM"
            ? createDamagedClaim(kyInstance, {
                depositRecordIds: sendDrIds,
                communicationType: formData.communicationType,
                subject: formData.subject,
                body: formData.body,
                recipientAddress: formData.recipientAddress,
                notes: formData.notes,
            }).then(function (created) { return ({
                processedCount: created.length,
                skipped: undefined,
                result: undefined,
            }); })
            : createUrgence(kyInstance, {
                depositRecordIds: sendDrIds,
                communicationType: formData.communicationType,
                subject: formData.subject,
                body: formData.body,
                recipientAddress: formData.recipientAddress,
                notes: formData.notes,
                enforcementType: enforcementKind,
            }).then(function (result) {
                var _a, _b;
                return ({
                    // the module answers with non_empty inclusion, so an empty list can arrive absent
                    processedCount: ((_a = result.processed) !== null && _a !== void 0 ? _a : []).length,
                    skipped: (_b = result.skipped) !== null && _b !== void 0 ? _b : [],
                    result: result,
                });
            });
    }, {
        onSuccess: function (_a) {
            var _b, _c;
            var processedCount = _a.processedCount, skipped = _a.skipped, result = _a.result;
            invalidateMatrices();
            invalidateDepositRecordViews(queryClient);
            queryClient.invalidateQueries(["periodicalLibraries"]);
            if (result) {
                // Urgence and reminder report through the list behind this dialog, which outlives it.
                onResult === null || onResult === void 0 ? void 0 : onResult(result, enforcementKind);
                onClose();
                return;
            }
            // A damaged claim has no such result to hand over, so closing on a partial one would
            // make it vanish without a word; it stays on the selection phase with its notice.
            var skippedTotal = (_b = skipped === null || skipped === void 0 ? void 0 : skipped.length) !== null && _b !== void 0 ? _b : sendDrIds.length - processedCount;
            if (skippedTotal > 0) {
                setNoticeMessage((_c = summarizeSkippedRecords(skipped, formatMessage)) !== null && _c !== void 0 ? _c : formatMessage({ id: "ui-br-legaldeposits.periodicals.enforcement.skipped" }, { count: skippedTotal }));
                setPhase("select");
                return;
            }
            onClose();
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var code, messageIds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, readUrgenceErrorCode(error)];
                    case 1:
                        code = _a.sent();
                        if (code === "REMINDER_ALREADY_ACTIVE") {
                            setNoticeMessage(formatMessage({
                                id: "ui-br-legaldeposits.enforcement.error.REMINDER_ALREADY_ACTIVE",
                            }));
                            setPhase("select");
                            return [2 /*return*/];
                        }
                        messageIds = code === UrgenceSkipReasonEnum.REMINDER_ALREADY_SENT
                            ? ALL_ALREADY_REMINDED_MESSAGE_IDS
                            : SEND_FAILED_MESSAGE_IDS;
                        setNoticeMessage(formatMessage({ id: messageIds[enforcementKind] }));
                        setPhase("select");
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var handleSend = useCallback(function (formData) { return sendMutation.mutate(formData); }, [sendMutation]);
    var handleBackToSelect = useCallback(function () { return setPhase("select"); }, []);
    var repeatedNotice = useMemo(function () {
        var _a;
        var repeated = ((_a = preview === null || preview === void 0 ? void 0 : preview.titles) !== null && _a !== void 0 ? _a : []).filter(function (t) { return t.previouslyEnforced; });
        var forecast = summarizeSkippedRecords(preview === null || preview === void 0 ? void 0 : preview.skipped, formatMessage);
        if (repeated.length === 0 && !forecast) {
            return null;
        }
        var list = repeated
            .map(function (title) {
            var _a, _b;
            return title.lastSentDate
                ? formatMessage({
                    id: "ui-br-legaldeposits.periodicals.enforcement.repeatedUrgence.item",
                }, {
                    label: (_a = title.issueLabel) !== null && _a !== void 0 ? _a : title.titleName,
                    date: formatDate(title.lastSentDate),
                })
                : formatMessage({
                    id: "ui-br-legaldeposits.periodicals.enforcement.repeatedUrgence.itemNoDate",
                }, { label: (_b = title.issueLabel) !== null && _b !== void 0 ? _b : title.titleName });
        })
            .join(", ");
        return (React.createElement(React.Fragment, null,
            repeated.length > 0 && (React.createElement(MessageBanner, { type: "warning", "data-testid": "periodical-repeated-urgence" }, formatMessage({
                id: "ui-br-legaldeposits.periodicals.enforcement.repeatedUrgence",
            }, { list: list }))),
            forecast && (React.createElement(MessageBanner, { type: "warning", "data-testid": "urgence-forecast-skipped" }, formatMessage({ id: "ui-br-legaldeposits.enforcement.send.forecastSkipped" }, { summary: forecast })))));
    }, [preview, formatMessage, formatDate]);
    var hasEnforceableIssues = allEnforceableIssueIds.length > 0;
    var formatIssueDate = useIssueDateFormatter();
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { open: open && phase === "select", label: formatMessage({ id: DIALOG_TITLE_IDS[enforcementKind] }), onClose: onClose, size: "medium", footer: React.createElement(ModalFooter, null,
                React.createElement(Button, { buttonStyle: "primary", onClick: handleProceed, disabled: isLoading || selectedDrIds.length === 0 }, formatMessage({ id: "ui-br-legaldeposits.button.continue" })),
                React.createElement(Button, { onClick: onClose }, formatMessage({ id: "ui-br-legaldeposits.button.cancel" }))) },
            noticeMessage && (React.createElement(MessageBanner, { type: "warning" }, noticeMessage)),
            isLoading ? (React.createElement(Loading, null)) : hasEnforceableIssues ? (React.createElement(AccordionStatus, null,
                React.createElement(ExpandAllButton, null),
                React.createElement(AccordionSet, null, enforceableVolumes.map(function (volumeGroup) {
                    var total = volumeGroup.issues.length;
                    var selectedInVolume = volumeGroup.issues.reduce(function (count, issue) {
                        return selectedIssueIds.has(issue.id) ? count + 1 : count;
                    }, 0);
                    var volumeCheckbox = (React.createElement(VolumeCheckbox, { label: formatMessage({
                            id: "ui-br-legaldeposits.periodicals.enforcement.yearSelectedCount",
                        }, { selected: selectedInVolume, total: total }), checked: selectedInVolume === total, indeterminate: selectedInVolume > 0 && selectedInVolume < total, onChange: function () { return toggleVolume(volumeGroup.issues); } }));
                    return (React.createElement(Accordion, { key: volumeGroup.volume.id, id: "enforcement-volume-".concat(volumeGroup.volume.id), closedByDefault: volumeGroup.volume.id !== newestVolumeId, label: formatMessage({ id: VOLUME_ACCORDION_LABEL_IDS[enforcementKind] }, {
                            volume: volumeGroup.volume.label,
                            count: total,
                        }), displayWhenOpen: volumeCheckbox, displayWhenClosed: volumeCheckbox }, volumeGroup.issues.map(function (issue) {
                        var copiesCount = relevantDrIds(issue, enforcementKind).length;
                        var expectedDateText = formatIssueDate(issue.expectedDate);
                        return (React.createElement("div", { key: issue.id, className: css.issueRow },
                            React.createElement(Checkbox, { label: issue.label, checked: selectedIssueIds.has(issue.id), onChange: function () { return toggleIssue(issue.id); } }),
                            copiesCount > 1 && (React.createElement("span", { className: css.copiesPill }, formatMessage({
                                id: "ui-br-legaldeposits.periodicals.enforcement.copiesBadge",
                            }, { count: copiesCount }))),
                            expectedDateText && (React.createElement("span", { className: css.issueDate }, expectedDateText))));
                    })));
                })),
                React.createElement(MessageBanner, { type: selectedIssueCount > 0 ? "success" : "warning" }, selectedIssueCount > 0
                    ? formatMessage({
                        id: "ui-br-legaldeposits.periodicals.enforcement.selectionSummary",
                    }, {
                        count: selectedIssueCount,
                        volumes: selectedVolumeLabels.join(", "),
                    })
                    : formatMessage({
                        id: "ui-br-legaldeposits.periodicals.enforcement.selectionSummaryNone",
                    })))) : (React.createElement(MessageBanner, { type: "warning" }, formatMessage({ id: NO_ISSUES_MESSAGE_IDS[enforcementKind] })))),
        React.createElement(SendEnforcementDialog, { open: open && phase === "send", onClose: onClose, onBack: handleBackToSelect, onSubmit: handleSend, preview: preview, isLoading: previewQuery.isLoading || sendMutation.isLoading, dialogTitleId: SEND_TITLE_IDS[enforcementKind], submitNoteLabelId: SUBMIT_NOTE_LABEL_IDS[enforcementKind], notice: repeatedNotice })));
};
